module.exports = __webpack_public_path__ + "static/media/wordpress-ai-option-br.a63cb036.png";